var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33868 10.5769L1.33868 11C1.11429 11 0.898731 10.9086 0.739781 10.7434C0.423454 10.414 0.419724 9.88729 0.730873 9.55262L4.50394 5.49982L0.730922 1.44708C0.419681 1.11288 0.423413 0.585948 0.740031 0.256267C1.07243 -0.0892596 1.61963 -0.0847377 1.94621 0.265943L6.26954 4.90967C6.57686 5.24029 6.57686 5.75936 6.26931 6.09022L1.94639 10.7335C1.78726 10.9046 1.56768 11 1.33868 11L1.33868 10.5769Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.bf78739c585798aea7b58fafb7ec4a36.svg";
export { ForwardRef as ReactComponent };